import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

/**
 * Toaster component that displays a dialog with header and body content.
 *
 * @component
 * @param {Object} props - Component props.
 * @param {Object} props.props - Content props.
 * @param {node} props.props.header - The header content to be displayed in the dialog's title.
 * @param {node} props.props.body - The body content to be displayed in the dialog.
 * @returns {JSX.Element} The rendered Toaster component.
 */
function Toaster({ props }) {
	const [open, setOpen] = React.useState(true);
	const handleClose = () => {
		setOpen(false);
	};

	return (
		<React.Fragment>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">
					{props.header}
				</DialogTitle>
				<DialogContent>
					{props.body}
					<DialogContentText id="alert-dialog-description">
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button>Refresh</Button>
				</DialogActions>
			</Dialog>
		</React.Fragment>
	);
}

Toaster.propTypes = {
	props: PropTypes.shape({
		header: PropTypes.node.isRequired,
		body: PropTypes.node.isRequired,
	}).isRequired,
};

export default Toaster;
